<template>
    <JsonSchemaPhoneForm
        v-if="form.schema.format === 'phone'"
        v-bind="propsWithListenerAttrs"
        :disabled="isImmutable || disabled || rbacDisabled"
        :rbac-disabled="rbacDisabled"
        @blur="$emit('change')"
    >
        <template #icon>
            <LockInputIcon v-if="isImmutable || rbacDisabled" />
            <slot v-else name="icon" />
        </template>
    </JsonSchemaPhoneForm>
    <JsonSchemaEmailForm
        v-else-if="form.schema.format === 'email'"
        v-bind="propsWithListenerAttrs"
        :disabled="isImmutable || disabled || rbacDisabled"
        :rbac-disabled="rbacDisabled"
        @change="$emit('change', $event)"
    >
        <template #icon>
            <LockInputIcon v-if="isImmutable || rbacDisabled" />
            <slot v-else name="icon" />
        </template>
    </JsonSchemaEmailForm>
    <JsonSchemaTextForm
        v-else
        v-bind="propsWithListenerAttrs"
        :disabled="isImmutable || disabled || rbacDisabled"
        :rbac-disabled="rbacDisabled"
        @change="$emit('change', $event)"
    >
        <template #icon>
            <LockInputIcon v-if="isImmutable || rbacDisabled" />
            <slot v-else name="icon" />
        </template>
    </JsonSchemaTextForm>
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import { FormElement } from '@evidentid/dashboard-commons/components/Form';
    import AbstractJsonSchemaForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/AbstractJsonSchemaForm';
    import JsonSchemaEmailForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/JsonSchemaEmailForm.vue';
    import JsonSchemaPhoneForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/JsonSchemaPhoneForm.vue';
    import JsonSchemaTextForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/JsonSchemaTextForm.vue';
    import LockInputIcon from '@evidentid/dashboard-commons/components/LockInputIcon/LockInputIcon.vue';
    import { JsonFormBase } from '@evidentid/json-schema/interfaces/JsonForm';
    import { JsonSchemaString } from '@evidentid/json-schema/interfaces/JsonSchema';

    type JsonFormString = JsonFormBase<JsonSchemaString>;

    @Component({
        emits: [ 'change' ],
        components: {
            JsonSchemaEmailForm,
            JsonSchemaTextForm,
            JsonSchemaPhoneForm,
            FormElement,
            LockInputIcon,
        },
        inheritAttrs: false,
    })
    export default class EntityDetailsStringForm extends AbstractJsonSchemaForm<JsonFormString, string> {
        /** Fields the schema marks `readOnly` — shown with a padlock and never editable. */
        private get isImmutable(): boolean {
            return Boolean(this.form.schema.readOnly);
        }
    }
</script>
